import React from 'react';
import {getLangCode, stringBundle} from '../../stringBundle';
import utils from "../../helpers/utils";

const localizedStringBundle = stringBundle(getLangCode());

const ModalFooter = () => (
  <div className="p-4 items-center flex flex-col">
    <div className="w-full">
      <div className="w-full ma-modal-info-divider"/>
      <div className="w-full footer-content-wrapper flex flex-col text-center text-xs text-grey leading-normal md:flex-row md:text-left">
        <div className="footer-content w-full flex pl-0 md:w-1/2 md:pl-2">
          <div className="invisible pt-2 md:pr-2 md:visible">
            <img src={utils.getCdnPath(`/icon-lock.png`)} className="w-4" alt="Lock Icon"/>
          </div>
          <div className="security-info w-full pb-2 text-center flex flex-col md:w-2/3 md:text-left">
                <span className="part1 w-full text-grey">
                  <span className="pr-2 md:hidden">
                   <img src={utils.getCdnPath(`/icon-lock.png`)} className="w-4" alt="Lock Icon"/>
                  </span>
                  {localizedStringBundle.ADD_ACCOUNT_FOOTER_TEXT1}
                </span>
            <span className="part2 w-full text-grey">{localizedStringBundle.ADD_ACCOUNT_FOOTER_TEXT2}</span>
          </div>
        </div>
        <div className="alarm w-full text-grey pr-2 text-center md:w-1/2 md:text-right">
          {localizedStringBundle.MANAGE_ACCOUNT_FOOTNOTE_1}<br/>{localizedStringBundle.MANAGE_ACCOUNT_FOOTNOTE_2}
        </div>
      </div>
    </div>
  </div>
)

export default ModalFooter;



// WEBPACK FOOTER //
// ./src/components/common/ModalFooter.js